import { T } from "services/lang/LanguageService";
import { ReportOptions } from "models/component-print-models";
import {
  DashboardComponentPropsBase,
  IComponentTimed,
} from "components/pages/dashboard/components/interfaces";
import { DatasetLoadingConf } from "../charts/interfaces";
import { IComponentTheme, IDateRange } from "../product-template-table/utils/interfaces";
import { AggregationOption } from "../product-template-bar-chart/product-template-bar-chart-editor/ProductTemplateBarChartTypes";

export interface PeriodicDataChartProps
  extends DashboardComponentPropsBase<ReportOptions>,
    IDateRange,
    IComponentTimed,
    IComponentTheme {
  valueDataset: string;
  title?: string;
  subtitle?: string;
  chartType?: ChartType;
  aggregationType: AggregationOption;
  loadConf: DatasetLoadingConf;
  comparisonPeriod: string;
  dateRangeSelectType: string;
  updateFrequency?: number;
  dateFrom?: string;
  dateTo?: string;
  width?: number;
  height?: number;
}

export enum ChartType {
  BAR = "bar",
  LINE = "line",
}

export enum DateOption {
  TO = "to",
  FROM = "from",
}

export enum DateRangeSelectType {
  CUSTOM = "CUSTOM",
  LOAD_CONF = "LOAD_CONF",
  MONTH = "MONTH",
  YEAR = "YEAR",
}

export enum ComparisonPeriod {
  HOURLY_DAILY = "hourly-daily",
  DAILY_WEEKLY = "daily-weekly",
  WEEKLY_MONTHLY = "weekly-monthly",
  MONTHLY_YEARLY = "monthly-yearly",
}

export type AggregatedEntry = {
  total: number;
  count: number;
  min: number;
  max: number;
};

export const chartTypeOptions = [
  { label: T("chart-type.bar-chart"), value: ChartType.BAR },
  { label: T("chart-type.line-chart"), value: ChartType.LINE },
];

export const comparisonPeriodOptions = [
  { label: T("comparison-period.hourly-daily"), value: ComparisonPeriod.HOURLY_DAILY },
  { label: T("comparison-period.daily-weekly"), value: ComparisonPeriod.DAILY_WEEKLY },
  { label: T("comparison-period.weekly-monthly"), value: ComparisonPeriod.WEEKLY_MONTHLY },
  { label: T("comparison-period.monthly-yearly"), value: ComparisonPeriod.MONTHLY_YEARLY },
];

export const dateRangeSelectTypeOptions = [
  { label: T("label.custom"), value: DateRangeSelectType.CUSTOM },
  { label: T("load-conf.load-config"), value: DateRangeSelectType.LOAD_CONF },
  { label: T("dataset-data-type.monthly"), value: DateRangeSelectType.MONTH },
  { label: T("dataset-data-type.yearly"), value: DateRangeSelectType.YEAR },
];
